import { render } from "./AbtestMessageBAddPage.vue?vue&type=template&id=55b5f09c"
import script from "./AbtestMessageBAddPage.vue?vue&type=script&lang=js"
export * from "./AbtestMessageBAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__